export function CrownedBirdLogo({ className = "w-9 h-9" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 32 32" fill="none">
      <ellipse cx="16" cy="18" rx="10" ry="8" fill="#FF6B35"/>
      <circle cx="22" cy="12" r="6" fill="#FF6B35"/>
      <circle cx="24" cy="11" r="1.5" fill="#1C1917"/>
      <polygon points="28,12 32,11 28,10" fill="#F59E0B"/>
      <polygon points="6,18 0,14 0,22" fill="#FF8558"/>
      <ellipse cx="14" cy="17" rx="5" ry="3" fill="#E65F2F"/>
      <polygon points="16,0 18,5 22,2 20,7 24,6 19,9 16,6 13,9 8,6 12,7 10,2 14,5" fill="#FFD700"/>
      <circle cx="16" cy="4" r="1.5" fill="#EF4444"/>
    </svg>
  )
}
